module.exports = __webpack_public_path__ + "static/img/4.dd889345.jpg";